import cn from 'classnames'
import type { CSSProperties, ElementRef, FC } from 'react'
import { useEffect, useRef } from 'react'

import css from './Cursor.css'

const SCROLL_OPTIONS: ScrollIntoViewOptions = { behavior: 'smooth', block: 'nearest' }

export const Cursor: FC<{
  isActive: boolean
  className?: string
  style?: CSSProperties
  type?: 'circle' | 'badge'
}> = ({ isActive, className, style, type = 'circle' }) => {
  const cursorRef = useRef<ElementRef<'div'>>(null)
  const resultClassName = cn(
    css.cursor,
    {
      [css.badge]: type === 'badge',
      [css.active]: isActive,
    },
    className,
  )

  useEffect(() => {
    if (isActive) {
      cursorRef.current?.parentElement?.scrollIntoView(SCROLL_OPTIONS)
    }
  }, [isActive])

  return <div ref={cursorRef} className={resultClassName} style={style} />
}
